import React from 'react'
import { connect } from 'react-redux'

import NavLink from 'app/components/util/lgy-nav-link/LgyNavLink'

const UserAdminNav = ({ location, match, user }) =>
  <aside className='sidenav sticky'>
    <ul className='usa-sidenav-list'>
      <li>
        <NavLink activeClassName={location.pathname === match.url ? 'usa-current' : ''} to={`${match.url}`}>
          Overview
        </NavLink>
      </li>
      {user.isAffiliate && <li>
        <NavLink activeClassName='usa-current' to={`${match.url}/affiliations`}>
          Affiliations
        </NavLink>
      </li>}
      <li>
        <NavLink activeClassName='usa-current' to={`${match.url}/contact`}>
          Contact Information
        </NavLink>
      </li>
      <li>
        <NavLink activeClassName='usa-current' to={`${match.url}/events`}>
          Events
        </NavLink>
      </li>
      <li>
        <NavLink activeClassName='usa-current' to={`${match.url}/permissions`}>
          Permissions
      </NavLink>
      </li>
      <li>
        <NavLink activeClassName='usa-current' to={`${match.url}/status`}>
          Status
        </NavLink>
      </li>
      <li>
        <NavLink activeClassName='usa-current' to={`${match.url}/external`}>
          External Connections
        </NavLink>
      </li>
    </ul>
  </aside>

const mapStateToProps = (state, ownProps) => ({
  user: state.adminState.userAdmin.users[ownProps.match.params.userId] || {},
})

export default connect(mapStateToProps)(UserAdminNav)
